// @ts-nocheck
import CRVLogo from "../../assets/png/assets/CRV.png";
import ALTLogo from "../../assets/svg/assets/ALT.svg";
import APTLogo from "../../assets/svg/assets/APT.svg";
import ARLogo from "../../assets/svg/assets/AR.svg";
import ARBLogo from "../../assets/svg/assets/ARB.svg";
import ATOMLogo from "../../assets/svg/assets/ATOM.svg";
import AVAXLogo from "../../assets/svg/assets/AVAX.svg";
import BANANALogo from "../../assets/svg/assets/BANANA.svg";
import BEAMXLogo from "../../assets/svg/assets/BEAMX.svg";
import BITCOINLogo from "../../assets/svg/assets/BITCOIN.svg";
import BLASTLogo from "../../assets/svg/assets/BLAST.svg";
import BLURLogo from "../../assets/svg/assets/BLUR.svg";
import BLZLogo from "../../assets/svg/assets/BLZ.svg";
import BNBLogo from "../../assets/svg/assets/BNB.svg";
import BONKLogo from "../../assets/svg/assets/BONK.svg";
import BTCLogo from "../../assets/svg/assets/BTC.svg";
import CANTOLogo from "../../assets/svg/assets/CANTO.svg";
import DOGELogo from "../../assets/svg/assets/DOGE.svg";
import DYDXLogo from "../../assets/svg/assets/DYDX.svg";
import DYMLogo from "../../assets/svg/assets/DYM.svg";
import ETHLogo from "../../assets/svg/assets/ETH.svg";
import MONLogo from "../../assets/svg/assets/MON.svg";
import FALLBACKLogo from "../../assets/svg/assets/FALLBACK.svg";
import FRIENDLogo from "../../assets/svg/assets/FRIEND.svg";
import GLMRLogo from "../../assets/svg/assets/GLMR.svg";
import HIFILogo from "../../assets/svg/assets/HIFI.svg";
import ILVLogo from "../../assets/svg/assets/ILV.svg";
import INJLogo from "../../assets/svg/assets/INJ.svg";
import JITOLogo from "../../assets/svg/assets/JITO.svg";
import JUPLogo from "../../assets/svg/assets/JUP.svg";
import LDOLogo from "../../assets/svg/assets/LDO.svg";
import LINKLogo from "../../assets/svg/assets/LINK.svg";
import MANTALogo from "../../assets/svg/assets/MANTA.svg";
import MATICLogo from "../../assets/svg/assets/MATIC.svg";
import MEMELogo from "../../assets/svg/assets/MEME.svg";
import MINALogo from "../../assets/svg/assets/MINA.svg";
import MKRLogo from "../../assets/svg/assets/MKR.svg";
import NMRLogo from "../../assets/svg/assets/NMR.svg";
import NTRNLogo from "../../assets/svg/assets/NTRN.svg";
import OPLogo from "../../assets/svg/assets/OP.svg";
import ORDILogo from "../../assets/svg/assets/ORDI.svg";
import OXLogo from "../../assets/svg/assets/OX.svg";
import PARCLLogo from "../../assets/svg/assets/PARCL.svg";
import PEPELogo from "../../assets/svg/assets/PEPE.svg";
import PIXELLogo from "../../assets/svg/assets/PIXEL.svg";
import PORTALLogo from "../../assets/svg/assets/PORTAL.svg";
import PRIMELogo from "../../assets/svg/assets/PRIME.svg";
import PYTHLogo from "../../assets/svg/assets/PYTH.svg";
import RNDRLogo from "../../assets/svg/assets/RNDR.svg";
import SATSLogo from "../../assets/svg/assets/SATS.svg";
import SEILogo from "../../assets/svg/assets/SEI.svg";
import SHFLLogo from "../../assets/svg/assets/SHFL.svg";
import SOLLogo from "../../assets/svg/assets/SOL.svg";
import STRAXLogo from "../../assets/svg/assets/STRAX.svg";
import STRKLogo from "../../assets/svg/assets/STRK.svg";
import SUILogo from "../../assets/svg/assets/SUI.svg";
import SYNLogo from "../../assets/svg/assets/SYN.svg";
import TLogo from "../../assets/svg/assets/T.svg";
import TAOLogo from "../../assets/svg/assets/TAO.svg";
import TIALogo from "../../assets/svg/assets/TIA.svg";
import TRBLogo from "../../assets/svg/assets/TRB.svg";
import TRXLogo from "../../assets/svg/assets/TRX.svg";
import UMALogo from "../../assets/svg/assets/UMA.svg";
import WLDLogo from "../../assets/svg/assets/WLD.svg";
import XRPLogo from "../../assets/svg/assets/XRP.svg";
import ZETALogo from "../../assets/svg/assets/ZETA.svg";
import USDCLogo from "../../assets/svg/assets/usdc.svg";
import USDTLogo from "../../assets/svg/assets/usdt.svg";
import TONLogo from "../../assets/svg/assets/TON.svg";

export const EUROCLogo = "https://assets.coingecko.com/coins/images/26045/standard/euro.png?1696525125";
export const TSLALogo = "https://app.hyperliquid.xyz/coins/xyz:TSLA.svg";
export const NVDALogo = "https://app.hyperliquid.xyz/coins/xyz:NVDA.svg";
export const AAPLLogo = "https://app.hyperliquid.xyz/coins/xyz:AAPL.svg";
export const XAULogo = "https://app.hyperliquid.xyz/coins/xyz:GOLD.svg";
export const XAGLogo = "https://app.hyperliquid.xyz/coins/xyz:SILVER.svg";
export const JPYLogo = "https://app.hyperliquid.xyz/coins/xyz:JPY.svg";
export const SPXLogo = "https://app.hyperliquid.xyz/coins/xyz:SP500.svg";
export const ANTHROPICLogo = "https://app.hyperliquid.xyz/coins/vntl:ANTHROPIC.svg";

export {
  CRVLogo,
  ALTLogo,
  APTLogo,
  ARLogo,
  ARBLogo,
  ATOMLogo,
  AVAXLogo,
  BANANALogo,
  BEAMXLogo,
  BITCOINLogo,
  BLASTLogo,
  BLURLogo,
  BLZLogo,
  BNBLogo,
  BONKLogo,
  BTCLogo,
  CANTOLogo,
  DOGELogo,
  DYDXLogo,
  DYMLogo,
  ETHLogo,
  MONLogo,
  FALLBACKLogo,
  FRIENDLogo,
  GLMRLogo,
  HIFILogo,
  ILVLogo,
  INJLogo,
  JITOLogo,
  JUPLogo,
  LDOLogo,
  LINKLogo,
  MANTALogo,
  MATICLogo,
  MEMELogo,
  MINALogo,
  MKRLogo,
  NMRLogo,
  NTRNLogo,
  OPLogo,
  ORDILogo,
  OXLogo,
  PARCLLogo,
  PEPELogo,
  PIXELLogo,
  PORTALLogo,
  PRIMELogo,
  PYTHLogo,
  RNDRLogo,
  SATSLogo,
  SEILogo,
  SHFLLogo,
  SOLLogo,
  STRAXLogo,
  STRKLogo,
  SUILogo,
  SYNLogo,
  TLogo,
  TAOLogo,
  TIALogo,
  TRBLogo,
  TRXLogo,
  UMALogo,
  WLDLogo,
  XRPLogo,
  ZETALogo,
  USDCLogo,
  USDTLogo,
  TONLogo,
};
